import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of PENDING refill requests routed to this provider
 *  (incl. covered providers), for the "Schedule" nav + Refill Requests badge. */
export function useRefillRequests(intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let active = true;
        const fetchCount = () => api.get("/provider/refill-requests/count")
            .then((r) => { if (active) setCount(r.data.count || 0); })
            .catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        return () => { active = false; clearInterval(id); };
    }, [intervalMs]);
    return count;
}
